const navbarProductOptions = (t) => ([
  {
    title: t('factoring name'),
    subtitle: 'Adelanta el pago de tus facturas',
    url: '/factoring',
  },
  {
    title: 'Ordering',
    subtitle: 'Financia tus órdenes de compra',
    url: '/ordering',
  },
  {
    title: 'Confirming',
    subtitle: 'Extiende el plazo de pago a tus proveedores',
    url: '/confirming',
  },
  {
    title: 'Pronto pago',
    subtitle: 'Permite a tus proveedores adelantar sus facturas',
    url: '/pronto-pago',
  },
  {
    title: 'Kobros',
    subtitle: 'Gestiona tu cobranza',
    url: '/kobros',
  },
]);

export default navbarProductOptions;
